import { Container, Row, Col, Button  } from 'react-bootstrap';
import book from './assets/Il-tasto-giusto-Caterina-Vivarelli.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import bookPDF from './assets/IL_TASTO_GIUSTO_Caterina_Vivarelli.pdf';
import { Link } from 'react-router-dom';
import piano from './assets/Pianoforte_Caterina_Vivarelli1.jpg'
import React, { useState } from 'react';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const SectionsCard = ({ image, title, description, link }) => {
    return (
        <div className='col-12 col-lg-4 d-flex flex-column justify-content-center align-items-center rounded-2 p-5 mb-4'>
            <a href={link} className='text-decoration-none'>
                <div className='text-center'>
                    <img className='d-block img-fluid' src={image} />
                    <p className='display-6 mb-0 mt-3 mb-1 textc-accent fw-bold'>{title}</p>
                </div>
            </a>
        </div>
    );
};

function PictureSection({image, orientation}) {
    return (
        <Col lg={6} data-aos="fade-up" data-aos-delay="200" className={`${orientation ? "pe-lg-5" : "ps-lg-5 mt-4 mt-lg-0"} d-flex flex-column`}>
            <img src={image} className="img-fluid rounded-4 object-fit-cover" alt="Profile" style={{ height: '100%' }}></img>
        </Col>
    );
}

function TextSection() {
    const { t } = useTranslation(); // Inizializza il sistema di traduzione
    return (
        <Col lg={6} className="mt-3 mt-lg-0 d-flex flex-column justify-content-center">
            <h6 data-aos="fade-up" data-aos-delay="200" className="display-6 fw-bolder underline w-max mb-3">{t("homepage_teaching.title")}</h6>
            <p
                data-aos="fade-up"
                data-aos-delay="400"
                className="my-0 small opacity-75"
                dangerouslySetInnerHTML={{ __html: t('homepage_teaching.description') }} // Correct placement here
            >
            </p>
            <Link to={"/lezioni"} data-aos="fade-up" data-aos-delay="200" className='d-block w-max bg-accent text-light fw-bolder rounded-2 text-light py-2 mt-3 px-3 text-decoration-none'>{t("homepage_teaching.button")}</Link>
        </Col>
    );
}

const Recensioni = () => {
    const { t } = useTranslation(); // Inizializza il sistema di traduzione
    const recensioni = [
        t("reviews.review_1"),
        t("reviews.review_2"),
        t("reviews.review_3"),
        t("reviews.review_4"),
        t("reviews.review_5"),
        t("reviews.review_6"),
        t("reviews.review_7")
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % recensioni.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + recensioni.length) % recensioni.length);
    };

    // Dividi ogni recensione in due parti: numero e contenuto
    const [numero, contenuto] = recensioni[currentIndex].split(":");

    return (
        <div className='bg-dark-subtle bg-opacity-25 py-5 rounded-4 recensione mt-4'>
            <Container className="text-center">
                <Row className='d-flex justify-content-between align-items-center' style={{minHeight: 225}}>
                    <Col xs={2} className='d-flex align-items-center justify-content-center'>
                        <Button variant="light" onClick={handlePrev}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </Button>
                    </Col>
                    <Col xs={8}>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                            <p><strong>{numero}</strong></p>
                            <p>{contenuto.trim()}</p>
                        </div>
                    </Col>
                    <Col xs={2} className='d-flex align-items-center justify-content-center'>
                        <Button variant="light" onClick={handleNext}>
                            <FontAwesomeIcon icon={faChevronRight} />
                        </Button>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

    export default function Homepage({ features, Banner }) {
        return (
        <>
            <Container>
            <div className='d-flex flex-wrap justify-content-between pt-5'>
                {features.map((feature, index) => (
                <SectionsCard key={index} {...feature} />
                ))}
            </div>
            </Container>
            {Banner && <div>{Banner}</div>}
            <Container className='my-4'>
            <Row>
                <PictureSection orientation={true} image={piano}></PictureSection>
                <TextSection></TextSection>
            </Row>
            <Recensioni></Recensioni>
            </Container>
        </>
        );
    };